export const STATUS_LABEL = { present: "Present", half_day: "Half day", absent: "Absent" };

export const dayLabel = (v) => (v === 1 ? "Present" : v === 0.5 ? "Half day" : "Absent");

export const fmtDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

export const changeText = (a) => {
  const parts = [];
  if (a.status) parts.push(STATUS_LABEL[a.status]);
  if (a.ot_hours !== null && a.ot_hours !== undefined) parts.push(`OT ${a.ot_hours}h`);
  return parts.join(" · ") || "—";
};

export const prevMonth = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const DOW = ["M", "T", "W", "T", "F", "S", "S"];
export const dowLetter = (i) => DOW[i];
